import storage from './localStorage'

class Stack {
  constructor() {
    this.items = []
  }
  push(num) {
    this.items.push(num)
  }
  size() {
    return this.items.length
  }
  remove() {
    this.items.pop()
  }
  isEmpty() {
    return this.items.length === 0
  }
}

class StorageStack {
  constructor() {
    this.items = []
    this.count = 0
  }
  push(value) {
    this.items.push(value)
    storage.save(this.count, value)
  }
  size() {
    return this.items.length
  }
  remove() {
    this.items.pop()
    storage.remove(this.count + 1)
  }
  isEmpty() {
    return this.items.length === 0
  }
  item() {
    return this.items
  }
}

export {
  Stack,
  StorageStack
}



// WEBPACK FOOTER //
// ./src/common/Stack.js